/**
 * BOTTOM GENERAL INITS
 * ADVICE BREAKINGS NEWS
 */

import { BreakingNews } from "./breakingNews";


export class BreakingInits {
    constructor() {
        this.initMap();
    }

    initMap() {
        let dynamics = document.getElementsByClassName('breaking-news__dynamic');
        if (dynamics.length) {
            new BreakingNews(dynamics, 'breaking-news');
        }

        // Cintillo de últimas noticias
        let dynamicsLastNews = document.getElementsByClassName('breaking-news__slider');
        if (dynamicsLastNews.length) {
            new BreakingNews(dynamicsLastNews, 'breaking-last-news');
        }
    }
}
